import React, {
  createContext, useContext, useEffect, useState,
} from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const DEFAULT_SLUG = "peptichill-peptide-cooler-fridge";

const ProductContext = createContext(null);

/**
 * Single-fetch shared store for the catalogue product. Mounted once at the
 * storefront root so Hero, ProductSection, Specs and the PDP read from the
 * same MongoDB-backed source instead of stale hard-coded copy.
 */
export function ProductProvider({ children, slug = DEFAULT_SLUG }) {
  const [product, setProduct] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let alive = true;
    (async () => {
      try {
        const res = await axios.get(`${API}/products/${slug}`);
        if (!alive) return;
        setProduct(res.data);
        setError(null);
      } catch (e) {
        if (!alive) return;
        setError(e?.response?.data?.detail || "Unable to load product.");
      } finally {
        if (alive) setLoading(false);
      }
    })();
    return () => { alive = false; };
  }, [slug]);

  return (
    <ProductContext.Provider value={{ product, loading, error }}>
      {children}
    </ProductContext.Provider>
  );
}

export function useProduct() {
  const ctx = useContext(ProductContext);
  if (!ctx) throw new Error("useProduct must be used inside <ProductProvider>");
  return ctx;
}
